const ALIBABA_PAGE = '//www.alibaba.com';
const HOME_PAGE = '//dropshipping.alibaba.com';
const SEARCH_PRODUCT = '//dropshipping.alibaba.com/saas/search-product.html';
const IMPORT_LIST = '//dropshipping.alibaba.com/saas/import-list.html';
const MY_PRODUCTS = '//dropshipping.alibaba.com/saas/my-products.html';
const MESSAGE = '//dropshipping.alibaba.com/saas/messages.html';
const NOTIFICATIONS = '//dropshipping.alibaba.com/saas/notifications.html';
const MY_SHOP = '//dropshipping.alibaba.com/saas/my-shop.html';
const MY_ORDERS = '//dropshipping.alibaba.com/saas/my-orders.html';
const SETTING = '//dropshipping.alibaba.com/saas/settings.html';
const NOT_FIND = '//dropshipping.alibaba.com/saas/404.html';
const HELP = '//dropshipping.alibaba.com/saas/help.html';
const MY_SUPPLIERS = '//dropshipping.alibaba.com/saas/my-suppliers.html';
const PRODUCT_MAPPING_RECOMMENDATIONS =
  '//dropshipping.alibaba.com/saas/product/mapping-recommendations.html';

const START_DROP_SHIPPING = '//dropshipping.alibaba.com/buyer-growth/start-dropshipping/';
const LEARN_DROP_SHIPPING = '//dropshipping.alibaba.com/buyer-growth/learn-dropshipping/';
const SCALE_YOURS_SCALE = '//dropshipping.alibaba.com/buyer-growth/scale-your-sales/';
const FIND_IDEAL = '//dropshipping.alibaba.com/buyer-growth/find-ideas/';

export {
  ALIBABA_PAGE,
  HOME_PAGE,
  SEARCH_PRODUCT,
  IMPORT_LIST,
  MESSAGE,
  NOTIFICATIONS,
  MY_PRODUCTS,
  MY_ORDERS,
  MY_SHOP,
  SETTING,
  NOT_FIND,
  HELP,
  START_DROP_SHIPPING,
  LEARN_DROP_SHIPPING,
  SCALE_YOURS_SCALE,
  FIND_IDEAL,
  MY_SUPPLIERS,
  PRODUCT_MAPPING_RECOMMENDATIONS,
};
